var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Breakpoints } from '@doordash/design-language';
import styled from 'styled-components';
export var ErrorIconWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: ", "px;\n  width: ", "px;\n  @media (min-width: ", "px) {\n    height: ", "px;\n    width: ", "px;\n  }\n"])), function (props) {
  return props.containerHeight;
}, function (props) {
  return props.containerHeight;
}, Breakpoints.Mobile + 1, function (props) {
  return props.desktopContainerHeight;
}, function (props) {
  return props.desktopContainerHeight;
});